export default "__VITE_ASSET__CC$LUCpR__"